import React, { useState } from 'react'
import { Form } from 'react-bootstrap';
import { useGender } from '../../../context/GenderContext';

const GenderFilter = ({setCurrentPage}) => {
  const { selectedGender, setSelectedGender } = useGender();
  const handleChange = (e) => {
    setSelectedGender(e.target.value);
    setCurrentPage(1);
  };
  return (
    <>
      <div>
        <Form.Select
          value={selectedGender}
          onChange={handleChange}
          className="me-2"
          style={{ width: "100%", padding: "11px 50px 10px 11px" }}
        >
          <option value="0">Select Gender</option>
          <option value="M">Male</option>
          <option value="F">Female</option>
        </Form.Select>
      </div>
    </>
  );
};


export default GenderFilter